import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "pollFilter" })
export class PollFilter implements PipeTransform {
  transform(
    array: any[],
    active: boolean,
    projectFilter: string,
    nationalityFilter: string,
    employerFilter: string,
    countryFilter: string
  ): any[] {
    if (array) {
      return array.filter((poll) => {
        let result = true;
        result = !active || poll.active || false;
        if (result) {
          if (projectFilter && projectFilter !== "undefined") {
            result =
              poll.context.project_ids.filter((id) => {
                return id === projectFilter;
              }).length > 0;
          }
          if (result) {
            if (nationalityFilter && nationalityFilter !== "undefined") {
              result =
                poll.context.nationalities.filter((id) => {
                  return id === nationalityFilter;
                }).length > 0;
            }
            if (result) {
              if (employerFilter && employerFilter !== "undefined") {
                result =
                  poll.context.employer_ids.filter((id) => {
                    return id === employerFilter;
                  }).length > 0;
              }
              if (result) {
                if (countryFilter && countryFilter !== "undefined") {
                  result =
                    (poll.context.countries || []).filter((id) => {
                      return id === countryFilter;
                    }).length > 0;
                }
              }
            }
          }
        }
        return result;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/polls/polls.filter.ts